/** Fork + knife mark. Uses currentColor so it adapts to the header / page. */
export function LogoMark({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9 3v9a3 3 0 0 0 3 3h0a3 3 0 0 0 3-3V3" />
      <path d="M12 15v14" />
      <path d="M24 3c-2.5 0-4.5 3.2-4.5 8s2 5.5 4.5 5.5h0V3Z" />
      <path d="M24 16.5V29" />
    </svg>
  );
}
